export default "__VITE_ASSET__BdjjPPIZ__"